module.exports = __webpack_public_path__ + "static/media/Helvetica-Light-01.5b4d4778.svg";